import { render, staticRenderFns } from "./columnar.vue?vue&type=template&id=2ce1c676&scoped=true&lang=pug&"
import script from "./columnar.vue?vue&type=script&lang=js&"
export * from "./columnar.vue?vue&type=script&lang=js&"
import style0 from "./columnar.vue?vue&type=style&index=0&id=2ce1c676&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1c676",
  null
  
)

export default component.exports